import * as React from "react"
import { useScreenSize } from "@lib/hooks"
import { BsArrowLeft } from "react-icons/bs"
import DashboardHeaderMobile from "./components/DashboardHeaderMobile"
import { useUserData } from "@lib/context/ComponentContext"
import { TokenData } from "@interfaces/auth"
import { textShortener } from "@lib/functions"
import { FlexBox } from "@components/wrapper"
import { BasicLink } from "@components/typography"
import { Avatar } from "@components/misc"

export function DashboardHeader() {
  const { deviceType } = useScreenSize()
  const { tokenData } = useUserData()

  return (
    <>
      {deviceType === "web" ? (
        <div className="w-full bg-primary-grey sticky top-0 z-40">
          <FlexBox align="center" justify="between" className="pl-12 pr-20 py-4">
            <FlexBox align="center">
              <BasicLink href="/" className="flex align-center gap-3">
                <BsArrowLeft className="text-xl" />
                <span className="font-medium">Kembali ke halaman utama</span>
              </BasicLink>
            </FlexBox>
            <FlexBox align="center" className="font-medium text-grey-48 py-1.5">
              <Avatar
                className="h-9 w-9 mr-2.5"
                alt="avatar user"
                src={tokenData?.user_picture ?? ""}
                size={30}
              />
              <div className="font-normal">{textShortener(tokenData?.user_firstname ?? "", 8)}</div>
            </FlexBox>
          </FlexBox>
        </div>
      ) : (
        <DashboardHeaderMobile tokenData={tokenData as TokenData} />
      )}
    </>
  )
}
